import React, { useCallback } from 'react';
import { observer } from 'mobx-react-lite';
import { BetHistoryFilterTypes, BetHistoryContainer } from '@pascal/pascal-core';
import { betStore } from '@pascal/pascal-core/shared/core/store';
import { BetHistoryItem } from './betHistoryItem';

export const BetHistoryWrapper = observer(() => {
  const customAddHalfHistory = useCallback((data) => {
    const { betHistoryFilter } = betStore;
    const historyData = Array.from(
      data
        .reduce((acc, current) => {
          return acc.set(current.id, current);
        }, new Map())
        .values()
    );

    switch (betHistoryFilter) {
      case BetHistoryFilterTypes.Win: {
        return historyData.filter((bet) => bet.winAmount);
      }
      case BetHistoryFilterTypes.Lose: {
        return historyData.filter((bet) => !bet.winAmount);
      }
      case BetHistoryFilterTypes.All:
        return historyData;
      default:
        return [];
    }
  }, []);

  return (
    <BetHistoryContainer
      isGetViaSocket
      customStatus={null}
      renderBetHistoryItem={(bet) => <BetHistoryItem bet={bet} key={bet.id} />}
      filterNames={[
        BetHistoryFilterTypes.All,
        BetHistoryFilterTypes.Win,
        BetHistoryFilterTypes.Lose,
      ]}
      customBetHistoryParser={customAddHalfHistory}
    />
  );
});
